<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="团队成员：">
              <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.levelId" placeholder="请选择身份" clearable size="small">
                <el-option :label="item.name" :value="item.level" v-for="item in businessOption" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <!-- <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div> -->
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="团队成员" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.name }}</span>
                <span style="display: block;">{{ row.pho }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="团队成员" prop="teamCount" sortable align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/business/team',row,row.teamCount)">{{ row.teamCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户人数" prop="teamCustomerCount" sortable align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/business/customer',row,row.teamCustomerCount)">{{ row.teamCustomerCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="总业绩" prop="totalMoney" sortable align="center" width="100">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/business/achievement',row,row.totalMoney)">{{ row.totalMoney }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
// import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
import Times from '../../components/times.vue'
import Navs from '../../components/navs.vue'
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        teamCountSortSign:-1
        // isDisplay: 1,
        // keyword:'',
        // identity:''
      },
      selectItems: [],
      times: null,
      id:null,
      businessOption: [],
      navIndex: 0,
      today:''
    }
  },
  created() {
    //
    // const dayjs = require('dayjs');
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times={
      timeStart:`${this.today} 00:00:00`,
      timeEnd:`${this.today} 23:59:59`,
    }
    this.id=this.$route.query.id
    this.doQueryList({ pageNo: 1 })
    this.getBusinessStanding()
    // this.getTime()
    // console.log('this.$route.parmas.id',this.$route,this.id)
  },
  watch: {
    '$route'(to, from) {
      this.id=to.query.id
      // const dayjs = require('dayjs');
      this.today = this.dayjs().format('YYYY-MM-DD');
      this.times={
        timeStart:`${this.today} 00:00:00`,
        timeEnd:`${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    }
  },
  methods: {
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'teamCount': 'teamCountSortSign',
        'teamCustomerCount': 'customerCountSortSign',
        'totalMoney': 'totalMoneySortSign',
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.businessOption=data
        // console.log('客户身份: ', data);
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 获取时间段
     */
     getTime(event) {
      this.times = JSON.parse(event)
      if(!this.times.ifUse){
        this.doQueryList({ pageNo: 1 })
      }
      // console.log('this.times: ',this.times);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
     handleFilter() {
      // this.$refs.times.timeIndex = ''
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query={
        pageNo: 1,
        pageSize: 10,
        teamCountSortSign:-1
      }
      // this.query.identity = ''
      this.times = {
        timeStart:`${this.today} 00:00:00`,
        timeEnd:`${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
        this.navIndex = index;
        this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/business/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }

      this.listLoading = true
      let query={...this.query,parentId:this.id}
      if(this.times && this.times.timeStart){
        query.startTime=this.times.timeStart
        query.endTime=this.times.timeEnd
      }
      // if(this.navIndex){
      //   query.levelId=this.navList[this.navIndex].level
      // }else{
      //   delete query.levelId
      // }
      return clientListApi.getYeStatistics(query).then(({ data }) => {
        // data.list = [
        //   {name: '张三',phone: '15692915737',identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        // ]
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    // changeSwitch(row) {
    //   sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
    //     this.$common.showMsg('success', '操作成功')
    //   })
    // },
    /**
     * 页面跳转
     */
    toPage(path,row,num) {
      // if(!num) return
      // if(type) {
        // this.$router.push(`${path}?id=${row.id}&index=${type-1}`)
      // }else{
        this.$router.push(`${path}?id=${row.id}`)
      // }
    }
  }
}
</script>
<style scoped lang="scss">
  .filter-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0;
    .times {
      display: flex;
      align-items: center;
    }
    .btns {
      margin-bottom: 22px;
    }
  }
</style>
